import { AuthPageProps } from './types';

export const AuthPage = ({ children }: AuthPageProps) => <main className="flex flex-col-reverse md:flex-row flex-1">{children}</main>;